import {Component, HostBinding, OnInit, ViewChild} from '@angular/core';
import { MatPaginator as MatPaginator, PageEvent as PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {TenderDataSource} from '../../dataSources/tenderDataSource';
import {BehaviorSubject} from 'rxjs';
import {ArticleService} from '../../services/article.service';
import {UserService} from '../../../auth-client/services/user.service';
import * as moment from 'moment';
import {ShoppingService} from '../../services/shopping.service';
import {Router} from '@angular/router';

@Component({
    selector: 'brover-order-history',
    templateUrl: './order-history.component.html',
    standalone: false
})
export class OrderHistoryComponent implements OnInit {
  @HostBinding('class.brover-tenders') hasClass = true;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public displayedColumns: string[] = ['order_number', 'reference', 'settlement', 'articles', 'date', 'action'];
  public dataSource: TenderDataSource | null;

  public moment = moment;

  public itemsPerPage = 10;
  public itemsTotal = 0;
  public pageIndex = 0;

  allorders: any;

  private searchValue: string;

  private tenders: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  constructor(private router: Router, private articleService: ArticleService, private userService: UserService,
              public shoppingService: ShoppingService) { }

  ngOnInit() {
    this.loadOrders();
  }

  public applyFilter(filterValue: string) {
    this.searchValue = filterValue.trim().toLowerCase();
    if (this.pageIndex > 0) {
      this.pageIndex = 0;
    }

    this.loadOrders();
  }

  public changePage(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.itemsPerPage = event.pageSize;

    this.loadOrders();
  }

  private loadOrders() {
    this.articleService.Orders(this.pageIndex, this.itemsPerPage, this.searchValue).subscribe(x => {
      const array = [];
      this.itemsTotal = x.total;

      this.allorders = x.orders;

      x.orders.forEach(order => {
        const items: any[] = order.items;
        let reduced = 0;
        let price = 0;
        if (items.length > 0) {
          items.length === 1 ? reduced = items[0].qty :
            reduced = items.reduce((a, b) => a + (b['qty'] || 0), 0);
          items.length === 1 ? price = (items[0].qty * items[0].price) :
            price = items.reduce((a, b) => a + ((b['price'] * b['qty']) || 0), 0);
        }
        const article = {order_number: order.id, settlement: this.userService.getCompany().name, articles: reduced, date: order.created,
          price: price.toFixed(2), reference: order.reference};
        array.push(article);
      });
      this.tenders.next(array);
      this.dataSource = new TenderDataSource(this.tenders, this.sort);
    });
  }

  redoOrder(orderre) {
    const orderDetail = this.allorders.find(x => x.id === orderre.order_number);
    const copy: {
      deliverDate: Date,
      shoppingBag: any[],
      references?: string,
      car_type: any,
      brand: any,
      address: string,
      place: string,
      postal_code: string,
      tender?: any
    }  = this.shoppingService.order;

    copy.deliverDate = orderDetail.delivery_date;
    copy.shoppingBag = [];
    orderDetail.items.forEach(x => {
      copy.shoppingBag.push({articleNumber: x.article, qty: x.qty});
    });
    copy.references = orderDetail.reference;
    copy.car_type = orderDetail.car_type;
    copy.brand = orderDetail.brand;

    copy.address = orderDetail.address;
    copy.place = orderDetail.place;
    copy.postal_code = orderDetail.postal_code;
    copy.tender = orderDetail.tender;

    this.shoppingService.order = copy;
    this.router.navigate(['/', 'dashboard', 'order-history', orderDetail.id]);
  }
}
